export default "__VITE_ASSET__BoQhiM41__"